import {
    Button,
    MessageTooltip,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import { PencilLine } from '@archipro-design/icons';
import { useBoolean } from 'ahooks';
import type { BoardListWithImageOnlyPinsFragment } from 'generated/graphql';
import React from 'react';
import { useDesignBoardPageState } from '~/modules/design-board/component/context/DesignBoardContext';
import { BOARD_TILE_OVERLAY_CLASS } from '~/modules/design-board/config';
import { ToggleBottomMenuButton } from '~/modules/design-board/component/mobile-menu/ToggleBottomMenuButton';
import { useTracker } from '@archipro-website/tracker';

const OverlayButtons = ({
    board,
}: {
    board?: BoardListWithImageOnlyPinsFragment;
}) => {
    const [tooltipState, tooltipAction] = useBoolean();
    const { dispatch } = useDesignBoardPageState();
    const { mobile } = useAppDisplayModeContext();
    const tracker = useTracker();

    const onClickEdit = (e: React.SyntheticEvent<HTMLElement>) => {
        e.stopPropagation();
        e.preventDefault();
        if (board) {
            dispatch({
                type: 'OpenEditDrawer',
                designBoardInput: {
                    title: board.Title,
                    description:
                        board.Content !== null ? board.Content : undefined,
                    isPrivate: !board.Public,
                    id: board.ID,
                },
            });
            tracker.log('EditBoardReveal', {
                url: new URL(window.location.href),
                data: {
                    ElementID: 'designboard_detail_header_editBoardReveal',
                    Source: 'designBoard, detail, header',
                },
            });
        }
    };

    return (
        <div className={BOARD_TILE_OVERLAY_CLASS}>
            {mobile && board ? (
                <ToggleBottomMenuButton
                    bottomMenuData={{ type: 'board' }}
                    currentBoardData={board}
                />
            ) : board?.CanEdit ? (
                <MessageTooltip
                    open={tooltipState}
                    trigger={
                        <Button
                            icon={<PencilLine />}
                            size={36}
                            color="grey"
                            variables={{ buttonPadding: 4 }}
                            onClick={onClickEdit}
                            onMouseEnter={tooltipAction.setTrue}
                            onMouseLeave={tooltipAction.setFalse}
                            onMouseDown={tooltipAction.setFalse}
                        />
                    }
                    content={{
                        children: 'Edit board',
                        size: 16,
                        padding: 8,
                    }}
                    position="above"
                    offset={[0, 9]}
                />
            ) : (
                ''
            )}
        </div>
    );
};

export default OverlayButtons;
